import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ExpenseAddChild from "./ExpenseAddChild";

const ExpenseAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ExpenseAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ExpenseAdd;
